import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import "./Productaddproperties.scss";

const baseUrl = process.env.REACT_APP_BASEURL;

const ProductimageEdit = () => {
  const [productData, setProductData] = useState("");
  const [metadescription1, setMetadescription1] = useState("");
  const [metatitle1, setMetatitle1] = useState("");
  const [atltext1, setAtltext1] = useState("");

  const [metadescription2, setMetadescription2] = useState("");
  const [metatitle2, setMetatitle2] = useState("");
  const [atltext2, setAtltext2] = useState("");

  const [metadescription3, setMetadescription3] = useState("");
  const [metatitle3, setMetatitle3] = useState("");
  const [atltext3, setAtltext3] = useState("");


  
  const [metadescription4, setMetadescription4] = useState("");
  const [metatitle4, setMetatitle4] = useState("");
  const [atltext4, setAtltext4] = useState("");

  const [image, setImage] = useState(null); // Change the state to hold a File object
  const [image2, setImage2] = useState(null); // Change the state to hold a File object
  const [image3, setImage3] = useState(null); // Change the state to hold a File object
  const [image4, setImage4] = useState(null);
  const { id } = useParams();
  const fetchProductData = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/Ecomproduct/${id}`);
      setProductData(response.data);
      console.log(response.data, "response.data");
    } catch (error) {
      console.error("Failed to fetch product data", error);
    }
  };
  useEffect(() => {
    fetchProductData();
  }, [id]);

  const handleEditAltText = async () => {
    let value2=0;
    const formData = new FormData();
    formData.append("image", image); 
    formData.append("value", value2); 
    formData.append("atltext1", atltext1); 
    formData.append("metatitle1", metatitle1); 
    formData.append("metadescription1", metadescription1); 
    try {
      const response = await axios.put(
        `${baseUrl}/api/Ecomproduct/adminproductimageedit/${id}`,
        formData, // Send the FormData as the request body
        {
          headers: {
            "Content-Type": "multipart/form-data",
            // Authorization: `Bearer ${adminAuth?.token}`,
          },
        }
      );
      // Handle the response as needed
      console.log("Image upload success", response);
      fetchProductData();
      setImage("");
      setAtltext1("");
      setMetatitle1("");
      setMetadescription1("");

    } catch (error) {
      console.error("Failed to upload image", error);
    }
  };
  const handleEditAltText2 = async () => {
    let value2=1;
    const formData = new FormData();
    formData.append("image", image2); 
    formData.append("value", value2); 
    formData.append("atltext1", atltext2); 
    formData.append("metatitle1", metatitle2); 
    formData.append("metadescription1", metadescription2); 
    try {
      const response = await axios.put(
        `${baseUrl}/api/Ecomproduct/adminproductimageedit/${id}`,
        formData, 
        {
          headers: {
            "Content-Type": "multipart/form-data",
            // Authorization: `Bearer ${adminAuth?.token}`,
          },
        }
      );
      // Handle the response as needed
      console.log("Image upload success", response);
      fetchProductData();
      setImage2("");
      setMetadescription2("");
      setAtltext2("");
      setMetatitle2("");

    } catch (error) {
      console.error("Failed to upload image", error);
    }
  };
  const handleEditAltText3 = async () => {
    let value2=2;
    const formData = new FormData();
    formData.append("image", image3); 
    formData.append("value", value2); 
    formData.append("atltext3", atltext3); 
    formData.append("metatitle3", metatitle3); 
    formData.append("metadescription3", metadescription3); 
    try {
      const response = await axios.put(
        `${baseUrl}/api/Ecomproduct/adminproductimageedit/${id}`,
        formData, 
        {
          headers: {
            "Content-Type": "multipart/form-data",
            // Authorization: `Bearer ${adminAuth?.token}`,
          },
        }
      );
      // Handle the response as needed
      console.log("Image upload success", response);
      fetchProductData();
      setImage3("");
      setMetadescription3("");
      setMetatitle3("");
      setAtltext3("")
    } catch (error) {
      console.error("Failed to upload image", error);
    }
  };
  const handleEditAltText4 = async () => {
    let value2=3;
    const formData = new FormData();
    formData.append("image", image4); 
    formData.append("value", value2); 
    formData.append("atltext3", atltext4); 
    formData.append("metatitle3", metatitle4); 
    formData.append("metadescription3", metadescription4); 
    try {
      const response = await axios.put(
        `${baseUrl}/api/Ecomproduct/adminproductimageedit/${id}`,
        formData, 
        {
          headers: {
            "Content-Type": "multipart/form-data",
            // Authorization: `Bearer ${adminAuth?.token}`,
          },
        }
      );
      // Handle the response as needed
      console.log("Image upload success", response);
      fetchProductData();
      setImage4("");
      setMetadescription4("");
      setMetatitle4("");
      setAtltext4("")
    } catch (error) {
      console.error("Failed to upload image", error);
    }
  }; 
  const handleAddProperties=async()=>{
    const formData = new FormData();
    formData.append("image", image); 
   
    formData.append("alt", atltext2); 
    formData.append("metaTitle", metatitle2); 
    formData.append("metaDescription", metadescription2); 
    try {
      const response = await axios.post(
        `${baseUrl}/api/Ecomproduct/items/${id}/properties`,
        formData, 
        {
          headers: {
            "Content-Type": "multipart/form-data",
            // Authorization: `Bearer ${adminAuth?.token}`,
          },
        }
      );
      // Handle the response as needed
      console.log("Image upload success", response);
      fetchProductData();
      setImage3("");
      setMetadescription3("");
      setMetatitle3("");
      setAtltext3("")
    } catch (error) {
      console.error("Failed to upload image", error);
    }
  }
  const handleClickdelete=async(propertyid)=>{
console.log(propertyid,'id');
try {
    const response = await axios.delete(
      `${baseUrl}/api/Ecomproduct/deleteProperty/${id}/${propertyid}`,
    //   formData, 
      {
        headers: {
          "Content-Type": "multipart/form-data",
          // Authorization: `Bearer ${adminAuth?.token}`,
        },
      }
    );
    fetchProductData();
}catch(error){
    console.log(error);
}
  }
  return (
    <div>
      <h1 className="ProductImageEdithead">Product image Edit</h1>
      <table>
        <thead>
          <tr>
            <th>Image</th>
            <th>EDIT</th>
            <th>Delete</th>
          </tr>
        </thead>
        {productData &&
          productData.properties &&
          productData.properties[0] &&
          productData.properties[0].image ? (
            <tbody>
              <tr>
                <td>
                 
                  <img
                    src={productData.properties[0].image[0]}
                    style={{ height: "100px", width: "100px" }}
                    className="ecomproductdetailslimagediv"
                  />
                </td>
                
                <td>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <input
                      className="alttext"
                      id="atltext1"
                      placeholder={productData?.properties[0].alt_text}
                      value={atltext1}
                      onChange={(event) => setAtltext1(event.target.value)}
                    />
                    <input
                      className="alttext"
                      id="metatitle"
                      placeholder={productData?.properties[0]?.meta_title}
                      value={metatitle1}
                      onChange={(event) => setMetatitle1(event.target.value)}
                    />
                    <input
                      className="alttext"
                      id="metadescription"
                      placeholder={productData?.properties[0]?.meta_description}
                      value={metadescription1}
                      onChange={(event) => setMetadescription1(event.target.value)}
                    />
                    <input
                      type="file"
                      className="alttext"
                      placeholder="Enter image"
                      id="image"
                      name="image"
                      onChange={(event) => setImage(event.target.files[0])} // Update the image state
                    />
                    <button className="EditButton" onClick={handleEditAltText}>
                      Edit
                    </button>
                  </div>
                </td>
                <td><button className="DeleteButton" onClick={()=>{handleClickdelete(0)}}>Delete</button></td>
              </tr>
            </tbody>
          
          ) : (
            <tbody>
              <td>

          <Link to={`/addproperties/${id}`}>
            <button className="EditButton">ADD</button>
          </Link>
              </td>
              </tbody>
          )}

           {productData &&
          productData.properties &&
          productData.properties[1] &&
          productData.properties[1].image ? (
            <tbody>
              <tr>
                <td>
                  <img
                    src={productData.properties[1].image[0]}
                    style={{ height: "100px", width: "100px" }}
                    className="ecomproductdetailslimagediv"
                  />
                </td>
                <td>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <input
                      className="alttext"
                      id="atltext1"
                      placeholder={productData?.properties[1].alt_text}
                      value={atltext2}
                      onChange={(event) => setAtltext2(event.target.value)}
                    />
                    <input
                      className="alttext"
                      id="metatitle"
                      placeholder={productData?.properties[1]?.meta_title}
                      value={metatitle2}
                      onChange={(event) => setMetatitle2(event.target.value)}
                    />
                    <input
                      className="alttext"
                      id="metadescription"
                      placeholder={productData?.properties[1]?.meta_description}
                      value={metadescription2}
                      onChange={(event) => setMetadescription2(event.target.value)}
                    />
                    <input
                      type="file"
                      className="alttext"
                      placeholder="Enter image"
                      id="image"
                      name="image"
                      onChange={(event) => setImage2(event.target.files[0])} // Update the image state
                    />
                    <button className="EditButton" onClick={handleEditAltText2}>
                      Edit
                    </button>
                  </div>
                </td>
                <td><button className="DeleteButton" onClick={()=>{handleClickdelete(1)}}>Delete</button></td>

              </tr>
            </tbody>
          ):(
            <tbody>
              <td>

             <Link to={`/addproperties/${id}`}>
            <button className="EditButton">ADD</button>
          </Link>
              </td>
          </tbody>
          )}
           {productData &&
          productData.properties &&
          productData.properties[2] &&
          productData.properties[2].image ? (
            <tbody>
              <tr>
                <td>
                  <img
                    src={productData.properties[2].image[0]}
                    style={{ height: "100px", width: "100px" }}
                    className="ecomproductdetailslimagediv"
                  />
                </td>
                <td>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <input
                      className="alttext"
                      id="atltext1"
                      placeholder={productData?.properties[2].alt_text}
                      value={atltext3}
                      onChange={(event) => setAtltext3(event.target.value)}
                    />
                    <input
                      className="alttext"
                      id="metatitle"
                      placeholder={productData?.properties[2]?.meta_title}
                      value={metatitle3}
                      onChange={(event) => setMetatitle3(event.target.value)}
                    />
                    <input
                      className="alttext"
                      id="metadescription"
                      placeholder={productData?.properties[2]?.meta_description}
                      value={metadescription3}
                      onChange={(event) => setMetadescription3(event.target.value)}
                    />
                    <input
                      type="file"
                      className="alttext"
                      placeholder="Enter image"
                      id="image"
                      name="image"
                      onChange={(event) => setImage3(event.target.files[0])} // Update the image state
                    />
                    <button className="EditButton" onClick={handleEditAltText3}>
                      Edit
                    </button>
                  </div>
                </td>
                <td><button className="DeleteButton" onClick={()=>{handleClickdelete(2)}}>Delete</button></td>

              </tr>
            </tbody>
          ):(
            <tbody>
              <td>

             <Link to={`/addproperties/${id}`}>
            <button className="EditButton">ADD</button>
          </Link>
              </td>
          </tbody>
          )}


{productData &&
          productData.properties &&
          productData.properties[3] &&
          productData.properties[3].image ? (
            <tbody>
              <tr>
                <td>
                  <img
                    src={productData.properties[3].image[0]}
                    style={{ height: "100px", width: "100px" }}
                    className="ecomproductdetailslimagediv"
                  />
                </td>
                <td>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <input
                      className="alttext"
                      id="atltext1"
                      placeholder={productData?.properties[3].alt_text}
                      value={atltext4}
                      onChange={(event) => setAtltext4(event.target.value)}
                    />
                    <input
                      className="alttext"
                      id="metatitle"
                      placeholder={productData?.properties[3]?.meta_title}
                      value={metatitle4}
                      onChange={(event) => setMetatitle4(event.target.value)}
                    />
                    <input
                      className="alttext"
                      id="metadescription"
                      placeholder={productData?.properties[3]?.meta_description}
                      value={metadescription4}
                      onChange={(event) => setMetadescription4(event.target.value)}
                    />
                    <input
                      type="file"
                      className="alttext"
                      placeholder="Enter image"
                      id="image"
                      name="image"
                      onChange={(event) => setImage4(event.target.files[0])} // Update the image state
                    />
                    <button className="EditButton" onClick={handleEditAltText4}>
                      Edit
                    </button>
                  </div>
                </td>
                <td><button className="DeleteButton" onClick={()=>{handleClickdelete(2)}}>Delete</button></td>

              </tr>
            </tbody>
          ):(
            <tbody>
              <td>

             <Link to={`/addproperties/${id}`}>
            <button className="EditButton">ADD</button>
          </Link>
              </td>
          </tbody>
          )}
      </table>
    </div>
  );
};

export default ProductimageEdit;
